import React from 'react';
import PropTypes from 'prop-types';
import MarketplaceAdminBillPdf from "./marketplaceAdminBillPdf";

const MarketplaceAdminBillsView = ({bills, match}) => {
  const bill = bills.find(bill => bill.id.toString() === match.params.billId);

  if (!bill) {
    return '';
  }

  return (
    <div className="marketplace-admin__bills-bill">
      <MarketplaceAdminBillPdf bill={bill}/>
    </div>
  );
}

MarketplaceAdminBillsView.propTypes = {
  bills: PropTypes.array.isRequired,
};

MarketplaceAdminBillsView.defaultProps = {};

export default MarketplaceAdminBillsView;